<template>
  <el-form ref="form" :model="dataInfo"  :rules="rules" :hide-required-asterisk="true" label-position="top">

    <!-- 附件材料 -->
    <div class="white-box">
      <div class="label">附件材料</div>

      <el-form-item label="1、申报人身份证或护照" prop="sbrsfzFileIdList">
        <custom-upload v-model="dataInfo.sbrsfzFileIdList" :disabled="disabled"/>
      </el-form-item>
      <el-form-item label="2、申报人学历、学位证书" prop="sbrxlFileIdList">
        <custom-upload v-model="dataInfo.sbrxlFileIdList" :disabled="disabled"/>
      </el-form-item>
      <el-form-item label="3、申报人教育部出具的《国(境)外学历学位认证证书》或中国驻外使(领)馆出具的《留学回国人员证明》【选填】" prop="xlrzzsFileIdList">
        <custom-upload v-model="dataInfo.xlrzzsFileIdList" :disabled="disabled"/>
      </el-form-item>
      <el-form-item label="4、申报人职称证书【选填】" prop="zcFileIdList">
        <custom-upload v-model="dataInfo.zcFileIdList" :disabled="disabled"/>
      </el-form-item>
      <el-form-item label="5、申报人单位任职证明以及相关业绩证明材料" prop="sbrdwFileIdList">
        <custom-upload v-model="dataInfo.sbrdwFileIdList" :disabled="disabled"/>
      </el-form-item>
      <el-form-item label="6、申报人主要成果(专利证书、产品证书、代表性论著论文)及权威机构出具的检测报告、查新证明以及其他科技成果等有关证明文件【选填】" prop="sbrzycgFileIdList">
        <custom-upload v-model="dataInfo.sbrzycgFileIdList" :disabled="disabled"/>
      </el-form-item>
      <el-form-item label="7、申报人各类获奖证书、列入国家计划文件或主持各类重大项目证明材料【选填】" prop="hjzsFileIdList">
        <custom-upload v-model="dataInfo.hjzsFileIdList" :disabled="disabled"/>
      </el-form-item>
      <el-form-item label="8、已创办的企业还需提供企业相关证明材料(营业执照验资证明、公司章程、上年度企业财务报表(资产负债表损益表、现金流量表、企业主要研发成果等)【选填】" prop="yyzzFileIdList">
        <custom-upload v-model="dataInfo.yyzzFileIdList" :disabled="disabled"/>
      </el-form-item>
      <el-form-item label="9、项目情况表" prop="xmqkFileIdList">
        <template #label>
          <span>9、项目情况表 <el-button type="text" @click="downloadTemplate">【模板下载】</el-button></span>
        </template>
        <custom-upload v-model="dataInfo.xmqkFileIdList" :disabled="disabled"/>
      </el-form-item>
      <el-form-item label="10、路演ppt" prop="pptFileIdlList">
        <custom-upload v-model="dataInfo.pptFileIdlList" :disabled="disabled"/>
      </el-form-item>
      <el-form-item label="11、其他材料【选填】" prop="otherFileIdlList">
        <custom-upload v-model="dataInfo.otherFileIdlList" :disabled="disabled"/>
      </el-form-item>

    </div>


  </el-form>
</template>

<script>

import {toast} from '@/utils'
import {findByKey, toList, CARD_TYPE, YES_OR_NO} from '@/constant/Enums'
import CustomUpload from '@/components/custom-upload'
import ElButton from "../../../../../node_modules/element-ui/packages/button/src/button";

export default {
  components: {
    ElButton,
    CustomUpload,
  },
  props: {
    dataInfo: {
      type: Object,
      default: ()=>{
        return {
          sbrsfzFileIdList:[],//申报人身份证件材料
          sbrxlFileIdList:[],//申报人学历材料
          xlrzzsFileIdList:[],//教育部出具的学历认证证书或留学证明材料
          zcFileIdList:[],//申报人职称
          sbrdwFileIdList:[],//申报人单位任职证明以及相关业绩证明材料
          sbrzycgFileIdList:[],//申报人主要成果
          hjzsFileIdList:[],//申报人各类获奖证书
          yyzzFileIdList:[],//已创办的企业还需提供企业相关证明材料
          xmqkFileIdList:[],//项目情况表
          pptFileIdlList:[],//路演ppt
          otherFileIdlList:[],//其他材料
        }
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hasCoreUser: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    var checkFileList = (rule, value, callback, paramName) => {
      if (this.dataInfo[paramName].length == 0) {
        return callback(new Error());
      } else {
        return callback();
      }
    };
    return {
      rules: {
        sbrsfzFileIdList: [{ required: true, validator: (rule, value, callback)=> checkFileList(rule, value, callback, 'sbrsfzFileIdList'), message: '请上传申报人身份证或护照', trigger: 'blur' }],
        sbrxlFileIdList: [{ required: true, validator: (rule, value, callback)=> checkFileList(rule, value, callback, 'sbrxlFileIdList'), message: '请上传申报人学历、学位证书', trigger: 'blur' }],
        sbrdwFileIdList: [{ required: true, validator: (rule, value, callback)=> checkFileList(rule, value, callback, 'sbrdwFileIdList'), message: '请上传申报人单位任职证明以及相关业绩证明材料', trigger: 'blur' }],
        xmqkFileIdList: [{ required: true, validator: (rule, value, callback)=> checkFileList(rule, value, callback, 'xmqkFileIdList'), message: '请上传项目情况表', trigger: 'blur' }],
        pptFileIdlList: [{ required: true, validator: (rule, value, callback)=> checkFileList(rule, value, callback, 'pptFileIdlList'), message: '请上传路演ppt', trigger: 'blur' }],
      },

    }
  },
  watch: {
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    addStudyExp(){
      this.dataInfo.studyExpList.push({})
    },
    deleteStudyExp(index){
      this.dataInfo.studyExpList.splice(index, 1)
    },
    timeChange(times, data){
      if(times && times.length > 1) {
        data.startDate = times[0]
        data.endDate = times[1]
      } else {
        data.startDate = ''
        data.endDate = ''
      }
    },
    addWorkExp(){
      this.dataInfo.workExpList.push({})
    },
    deleteWorkExp(index){
      this.dataInfo.workExpList.splice(index, 1)
    },
    addZzqk(){
      this.dataInfo.sbrZzqkList.push({})
    },
    deleteZzqk(index){
      this.dataInfo.sbrZzqkList.splice(index, 1)
    },
    validate(callback){
      this.$refs['form'].validate((valid, object) => {
        callback && callback(valid, object)
      });
    },
    downloadTemplate() {
      let a = document.createElement('a')
      a.href = './static/project_situation.xls'
      a.download = '项目情况表.xls'
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      a.remove()
    },
  },
}
</script>

<style lang='less' scoped>
  @import url(./index.less);
</style>
